<div *ngIf="isDev" class="dev-ribbon" title="Running in Development Mode">
  <span class="dev-ribbon-badge">DEV</span>
  <span class="dev-ribbon-text">DEVELOPMENT ENVIRONMENT</span>
</div>
<router-outlet></router-outlet>
